// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3v-9c","col":"Table_col__2Cf53","fulfillmentStatus":"Table_fulfillmentStatus__Hr7Xo","emailCol":"Table_emailCol__3XBg3"};